import { ISector } from 'features/settings/topology/types';
import { BaseService } from 'shared/services/BaseService';

class LabelThresholdService extends BaseService<ISector> {
  constructor() {
    super('label-thresholds');
  }
}

export const labelThresholdService = new LabelThresholdService();
